import { render, staticRenderFns } from "./qxAreaDataboard.vue?vue&type=template&id=0ded21e8&scoped=true"
import script from "./qxAreaDataboard.vue?vue&type=script&lang=js"
export * from "./qxAreaDataboard.vue?vue&type=script&lang=js"
import style0 from "./qxAreaDataboard.vue?vue&type=style&index=0&id=0ded21e8&prod&lang=scss&scoped=true"
import style1 from "./qxAreaDataboard.vue?vue&type=style&index=1&id=0ded21e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ded21e8",
  null
  
)

export default component.exports